import React from "react";
import { SectionOne } from "./sectionOne";
import { SectionTwo } from "./sectionTwo";
import { SectionThree } from "./sectionThree";
import { SectionFour } from "./sectionFour";

import { BeforeFooterComponent, HeroComponent } from "components";
import { BalconyChilling, SuitesHero } from "assets";

const SuitesUI = () => {
	return (
		<div>
			<HeroComponent
				image={SuitesHero}
				statement={"SAVOR LUXURY, ONE BITE AT A TIME"}
				header={"WHERE COMFORT MEETS LUXURY: DISCOVER OUR SUITES"}
				backgroundColor={"#022626"}
				dotColor={"white"}
				top="-18%"
			/>
			<SectionOne />
			<SectionTwo />
			<SectionThree />

			<SectionFour />
			<BeforeFooterComponent
				image={BalconyChilling}
				templateTextColor="black"
				backgroundColor="#F6F5E1"
				paragraph="Experience unparalleled comfort and personalized service. Your satisfaction is our priority – enjoy a truly exceptional stay with us."
				heading="DISCOVER REFINED LUXURY"
				headingColor="black"
				paragraphColor="black"
				rotatingArrowColor="black"
			/>
		</div>
	);

};

export { SuitesUI };
